import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { NS1PEState, NS1PEDispatch } from './store';

export const useNS1PEDispatch = (): NS1PEDispatch =>
  useDispatch<NS1PEDispatch>();
export const useNS1PESelector: TypedUseSelectorHook<NS1PEState> = useSelector;
